// import jquery from 'jquery';

// アコーディョン
$(function () {
    const accordion = ($trigger) => {
        event.preventDefault();

        // const $target = $trigger.next('.js-accordion-target'),
        const $target = $trigger.closest('.js-accordion').find('.js-accordion-target'),
            toggleCls = 'is-open';

        if ($target.is(':animated')) { return; }

        if ($trigger.hasClass(toggleCls)) {
            $trigger.removeClass(toggleCls);
            $target.slideUp('fast');
        } else {
            $trigger.addClass(toggleCls);
            $target.slideDown('fast');
        }
    }

    const $module = $('.js-accordion');
    let windowWidth = window.innerWidth;

    $(window).on('load resize', function () {
       windowWidth = window.innerWidth;

        if ($module.hasClass('js-accordion-sp') ) {
            if (windowWidth >= 480) {
                $module.find('.js-accordion-trigger').removeClass('is-open');
            } else {
                $module.find('.js-accordion-target').removeAttr('style');
            }
        }
    });

    $module.on('click', '.js-accordion-trigger', function(){
        const $wrap = $(this).closest('.js-accordion');
        if ($wrap.hasClass('js-accordion-sp') && windowWidth >= 480) {
            return;
        }
        accordion($(this));
    });
});


// グロナビ
// $(function () {
//     let timeoutID;

//     const navPcHover = ($trigger, $target) => {
//         const toggleCls = 'is-open',
//             windowWidth = window.innerWidth;

//         event.preventDefault();

//         $target.stop().fadeIn('fast');
//     }
//     const navPcOut = ($trigger, $target) => {
//         const toggleCls = 'is-open',
//         windowWidth = window.innerWidth;

//         event.preventDefault();
//         if ($target.is(':hover')) {
//             return;
//         }
//         $target.stop().fadeOut();
//     }

//     const $navTriggerFamily = $('#js-gnav-family'),
//         $navTargetFamily = $('#js-subnav-family'),
//         $navTriggerBusiness = $('#js-gnav-business'),
//         $navTargetBusiness = $('#js-subnav-business');

//     $navTriggerFamily.on({
//         'mouseenter' : function () {
//             navPcHover($navTriggerFamily, $navTargetFamily);
//         },
//         'mouseleave': function () {
//             navPcOut($navTriggerFamily, $navTargetFamily);
//         }
//     });

//     $navTriggerBusiness.on({
//         'mouseenter': function () {
//             navPcHover($navTriggerBusiness, $navTargetBusiness);
//         },
//         'mouseleave': function () {
//             navPcOut($navTriggerBusiness, $navTargetBusiness);
//         }
//     });

//     $navTargetFamily.on('mouseleave', function () {
//         navPcOut($navTriggerFamily, $navTargetFamily);
//     });
//     $navTargetBusiness.on('mouseleave', function () {
//         navPcOut($navTriggerBusiness, $navTargetBusiness);
//     });
// });

// SPナビ
$(function () {
     const $gNav = $('#masthead');

    $(window).on('load resize', function () {
        const windowWidth = window.innerWidth;

        if (windowWidth >= 480) {
            $gNav.removeAttr('style');
        }
    });

    $('#js-globalSp').on('click', function(){
        $gNav.slideDown();
    })

    $('#js-globalSpClose').on('click', function () {
        $gNav.slideUp();
    })
})


// スムーーーススクロール
$(function () {
    $('a[href^="#"]').click(function () {
        event.preventDefault();
        if ($(this).hasClass('js-noAnk')) { return; }

        // スクロールの速度
        var speed = 400; // ミリ秒
        // アンカーの値取得
        var href = $(this).attr("href");
        // 移動先を取得
        var target = $(href == "#" || href == "" ? 'html' : href);
        // 移動先を数値で取得
        var position = target.offset().top;
        // スムーススクロール
        $('body,html').animate({ scrollTop: position }, speed, 'swing');
        return;
    });
});

// タブ
$(function() {
    $('.js-tabLabel').on('click', function () {
        const index = $(this).closest('li').index(),
            $module = $(this).closest('.js-tab'),
            activeClass = 'is-active';

        $module.find('.js-tabLabel').removeClass(activeClass);
        $module.find('.js-tabPanel').removeClass(activeClass).hide();
        $(this).addClass(activeClass);
        $module.find('.js-tabPanel').eq(index).fadeIn().addClass(activeClass);
    });
})

// タブセレ
$(function () {
    let windowWidth = window.innerWidth;

    const tabAction = ($trigger) => {
        const index = $trigger.closest('li').index(),
            $module = $trigger.closest('.js-tabSelect'),
            activeClass = 'is-active';

        $module.find('.js-tabSelectLabel').removeClass(activeClass);
        $module.find('.js-tabSelectPanel').removeClass(activeClass).hide();
        $trigger.addClass(activeClass);
        $module.find('.js-tabSelectPanel').eq(index).fadeIn().addClass(activeClass);
    }

    const selectOpen = ($trigger) => {
        const index = $trigger.closest('li').index(),
            $selectBox =$trigger.closest('.js-tabSelectLabel-wrap'),
            $module = $trigger.closest('.js-tabSelect'),
            activeClass = 'is-active';

        $selectBox.addClass(activeClass);
    }

    const selectAction = ($trigger) => {
        const index = $trigger.closest('li').index(),
            $module = $trigger.closest('.js-tabSelect'),
            $selectBox = $trigger.closest('.js-tabSelectLabel-wrap'),
            activeClass = 'is-active';

        $module.find('.js-tabSelectLabel').removeClass(activeClass);
        $module.find('.js-tabSelectPanel').removeClass(activeClass).hide();
        $trigger.addClass(activeClass);
        $module.find('.js-tabSelectPanel').eq(index).fadeIn().addClass(activeClass);
        $selectBox.removeClass(activeClass);
        $trigger.closest('ul').css('top', -40 * index + 'px');
    }

    const selectInit = () => {
        const $module = $('.js-tabSelect'),
            $selectBox = $module.find('.js-tabSelectLabel-wrap > ul'),
            index = $module.find('.is-active').closest('li').index();

        if (index) {
            $selectBox.css('top', -40 * index + 'px');
        }
        console.log('index:', index);
    }

    $(window).on('load resize', function () {
        windowWidth = window.innerWidth;

        if (windowWidth >= 480) {
            if ($('.js-tabSelectLabel-wrap').hasClass('is-active')) {
                $('.js-tabSelectLabel-wrap').removeClass('is-active').children('ul').removeAttr('style');
            }
        } else {
            selectInit();
        }
    });

    $('.js-tabSelectLabel').on('click', function () {
        const $that = $(this),
            thisHref = $that.attr("href");

        if (windowWidth >= 480) {
            tabAction($(this));
        } else {
            if ($(this).closest('.js-tabSelectLabel-wrap').hasClass('is-active')) {
                selectAction($that);
                if (thisHref !== "#") {
                    window.location.href = thisHref;
                }
                return false;
            }
        }
    });

    $('.js-tabSelect').on('click', function () {

        if (windowWidth < 480) {
            if ($(this).find('.js-tabSelectLabel-wrap')) {
                if($(this).hasClass('is-active')) {return;}
                selectOpen($(this).find('.js-tabSelectLabel'));
                console.log('if');
                return false;
            } else {
                console.log('else');
            }
        }
    });
})


/* ----------------------------------------------------------------------------------
各カテゴリの色分け判別
---------------------------------------------------------------------------------- */
$(function () {
    const $targets = $('#site-navigation').find('.gnav_main--li'),
        $dir = location.href.split('/'),
        $dir2 = $dir[$dir.length - 1], //ディレクトリ名、1階層目を取得
        $dir3 = $dir[$dir.length - 2], //ディレクトリ名、2階層目を取得
        $dir4 = $dir[$dir.length - 3],
        activeCls = 'is-active'; //ディレクトリ名、3階層目を取得

    if ($dir2 == 'family' || $dir3 == 'family' || $dir4 == 'family') {
        $targets.eq(0).addClass(activeCls);
    } else if ($dir2 == 'business' || $dir3 == 'business' || $dir4 == 'business') {
        $targets.eq(1).addClass(activeCls);
    } else if ($dir2 == 'qa' || $dir3 == 'qa' || $dir4 == 'qa') {
        $targets.eq(2).addClass(activeCls);
    } else if ($dir2 == 'news' || $dir3 == 'news' || $dir4 == 'news') {
        $targets.eq(3).addClass(activeCls);
    } else if ($dir2 == 'about' || $dir3 == 'about' || $dir4 == 'about') {
        $targets.eq(4).addClass(activeCls);
    }
});
